<script>
import date from 'locutus/php/datetime/date'
import defaults from 'lodash/defaults'
import {
  fetchCertificationType,
  createCertificationType,
  updateCertificationType,
} from '@apis/admin/kyc'
import LangItem from '@components/admin/lang-input'
import FormEditor from '@components/admin/form-editor'

export default {
  components: { LangItem, FormEditor },
  props: {
    type_seq: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      params: {
        use_valid_time: 'N',
      },
      info: null,
      loading: false,
      active_tab: 'info',
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loading = true
      Promise.all([this.loadCertificationType()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadCertificationType() {
      const { type_info } = await fetchCertificationType(this.type_seq)
      this.params = defaults(type_info, {
        title: '',
        name: '',
        use_valid_time: 'N',
        valid_time: 0,
        seq: null,
        regdate: null,
      })
      this.info = type_info
    },
    handleSubmit() {
      const createOrUpdate = this.params.seq
        ? updateCertificationType
        : createCertificationType
      const confirm_message = this.params.seq
        ? this.$t('admin.msg_save')
        : this.$t('admin.msg_enroll')
      const success_message = this.params.seq
        ? this.$t('admin.msg_kyc_type_modify')
        : this.$t('admin.msg_kyc_type_enroll')

      this.loading = true
      this.$confirm(confirm_message, this.$t('admin.modal_confirm'))
        .then(() => createOrUpdate(this.params))
        .then(({ seq }) => this.$emit('submit', seq))
        .then(() => this.$toasted.success(success_message))
        .catch((e) => (e ? this.$toasted.error(e.message) : null))
        .finally(() => {
          this.loading = false
        })
    },
    date,
  },
}
</script>

<template>
  <el-tabs v-model="active_tab" :stretch="true">
    <el-tab-pane :label="$t('admin.default_info')" name="info">
      <form
        v-loading="loading"
        action="./"
        method="get"
        @submit.prevent="handleSubmit"
      >
        <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
          <colgroup>
            <col width="20%" />
            <col width="30%" />
            <col width="20%" />
            <col width="30%" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row"
                ><div>{{ $t('admin.kyc_type_title') }}</div></th
              >
              <td
                ><LangItem v-if="!loading" v-model="params.title"></LangItem
              ></td>
              <th scope="row"
                ><div>{{ $t('admin.kyc_type_name') }}</div></th
              >
              <td>
                <template v-if="params.seq">{{ params.name }}</template>
                <input
                  v-else
                  v-model="params.name"
                  type="text"
                  :class="[$style.inputTypeText]"
              /></td>
            </tr>
            <tr>
              <th scope="col"
                ><div>{{ $t('admin.cdd_valid_time') }}</div></th
              >
              <td colspan="3">
                <i18n
                  :path="
                    `admin.kyc_certification_type_info.${params.use_valid_time}`
                  "
                >
                  <select v-model="params.use_valid_time">
                    <option value="N">{{ $t('admin.no_use') }}</option>
                    <option value="Y">{{ $t('admin.use') }}</option>
                  </select>
                  <template v-if="params.use_valid_time === 'Y'">
                    <input
                      v-model="params.valid_time"
                      type="text"
                      :class="[$style.inputTypeText, $style.w80, $style.tRight]"
                    />
                  </template>
                </i18n>
              </td>
            </tr>
            <tr>
              <th colspan="4" :class="$style.button">
                <span :class="[$style.button, $style.black]"
                  ><input
                    type="submit"
                    :value="params.seq ? $t('admin.save') : $t('admin.enroll')"
                /></span>
              </th>
            </tr>
          </tbody>
        </table>
      </form>
    </el-tab-pane>
    <el-tab-pane
      :disabled="!params.seq"
      :label="$t('admin.kyc_form')"
      name="KYC_CERTIFICATION"
    >
      <FormEditor
        v-if="params.seq"
        target_type="KYC_CERTIFICATION"
        :target_seq="params.seq"
      ></FormEditor>
    </el-tab-pane>
  </el-tabs>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
